<template>
  <div>
    <div class="row animated fadeInRightBig">
      <div class="col-md-12">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Planejamento</h5>
            <!--
            <div class="ibox-tools">
              <a
                class="dropdown-toggle"
                href="#"
                data-toggle="modal"
                data-target="#modal-filter"
              >
                <i class="fa fa-filter"></i> Filtros
              </a>
            </div>
            -->
          </div>

          <div class="ibox-content">
            <div class="row">
              <!--<div class="col-md-12">
                <div class="alert alert-info" role="alert">
                  <strong>
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    Atenção!
                  </strong>
                  Você só poderá adicionar eventos em dias que não possuam
                  nenhum evento programado.
                </div>
              </div>
            -->
              <div class="col-md-3">
                <p style="padding-top: 17px; margin: 0 0 5px">
                  Categoria de Tema
                </p>
                <select
                  class="form-control input-lg"
                  v-model="filter_selected.theme_category_id"
                  @change="getThemes()"
                >
                  <option value selected>Todos os Temas</option>
                  <option
                    :value="category.id"
                    v-for="(category, index) in themeCategories"
                    :key="index"
                  >
                    {{ category.description }}
                  </option>
                </select>

                <p class="text-center" style="margin: 11px 0">
                  Arraste o
                  <b>tema</b> para o <b>dia</b> desejado
                </p>

                <hr />

                <!-- glyphicon glyphicon-search -->
                <div class="input-group" style="margin-bottom: 15px">
                  <input
                    type="text"
                    v-model="themesSearchBar"
                    class="form-control"
                    placeholder="Procurar Assunto"
                    aria-describedby="basic-addon2"
                  />
                  <span class="input-group-addon" id="basic-addon2">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                </div>

                <div
                  class="widget yellow-bg p-xs text-center"
                  v-show="themes.length === 0 && loadTheme === true"
                >
                  <i class="fa fa-warning fa-2x"></i>
                  <h3 class="font-bold no-margins">Temas não encontrados!</h3>
                </div>
                <div
                  id="external-events"
                  class="scrollBar"
                  v-show="themes.length > 0 && loadTheme === true"
                >
                  <div v-if="filter_selected.theme_category_id == ''">
                    <div
                      v-for="(
                        category, indexCategory
                      ) in themesCategoriseFiltered"
                      :key="indexCategory"
                    >
                      {{ category.description }}
                      <div
                        v-for="(theme, index) in category.items"
                        :key="index + timeNow"
                        class="
                          external-event
                          navy-bg
                          ui-draggable ui-draggable-handle
                        "
                        v-bind:class="{ 'bg-orange': theme.special }"
                        :data-event="JSON.stringify(theme)"
                        :style="{
                          position: 'relative',
                          // 'display': 'inline-block',
                          'background-color':
                            indexCategory % 2 == 0 ? '#11548B' : '#1B99D3',
                          color: indexCategory % 2 == 0 ? 'white' : 'white',
                        }"
                      >
                        {{ theme.title }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    v-for="theme in themesFiltered"
                    :data-event="JSON.stringify(theme)"
                    :key="theme.id"
                    class="
                      external-event
                      navy-bg
                      ui-draggable ui-draggable-handle
                    "
                    v-bind:class="{ 'bg-orange': theme.special }"
                    :style="{
                      position: 'relative',
                      'background-color': '#1D99D3',
                      color: 'white',
                    }"
                  >
                    {{ theme.title }}
                  </div>
                </div>

                <hr style="margin-bottom: 0; margin-top: 12px" />

                <div class="p-sm">
                  <div style="display: block">
                    <span
                      style="
                        width: 12px;
                        height: 12px;
                        background: #f17436;
                        display: inline-block;
                        margin-right: 2px;
                      "
                    ></span>
                    Temas Especiais
                  </div>
                  <div style="display: block">
                    <span
                      v-show="filter_selected.theme_category_id == ''"
                      style="
                        width: 12px;
                        height: 12px;
                        background: #11548b;
                        display: inline-block;
                        margin-right: 2px;
                      "
                    ></span>
                    <span
                      style="
                        width: 12px;
                        height: 12px;
                        background: #1d99d3;
                        display: inline-block;
                        margin-right: 2px;
                      "
                    ></span>
                    Temas Normais
                  </div>
                </div>

                <hr style="margin-bottom: 0; margin-top: 0" />

                <div class="p-sm">
                  <input
                    type="checkbox"
                    v-model="special"
                    v-on:change="getThemes"
                  />
                  Eventos Especiais
                </div>
              </div>

              <div class="col-md-9 m-t-sm">
                <full-calendar
                  ref="calendar"
                  @event-receive="eventReceive"
                  @event-selected="eventClick"
                  :saveEvent="saveEvent"
                  :config="config"
                  :events="events"
                ></full-calendar>
                <!--
                <div class="row">
                  <div class="col-md-6">
                    <div class="p-sm">
                      <div style="display: block">
                        <span
                          style="
                            width: 12px;
                            height: 12px;
                            background: #0f528b;
                            display: inline-block;
                            margin-right: 2px;
                          "
                        ></span>
                        Eventos Planejados
                      </div>
                      <div style="display: block">
                        <span
                          style="
                            width: 12px;
                            height: 12px;
                            background: #149414;
                            display: inline-block;
                            margin-right: 2px;
                          "
                        ></span>
                        Eventos Programados
                      </div>
                    </div>
                  </div>
                </div>
                -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="modal-filter" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content animated fadeIn">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
            <h4 class="modal-title">Filtros</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Data de Cadastro - Inicial</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filters.whereBetween.created_at[0]"
                />
              </div>
              <div class="col-md-6 form-group">
                <label>Data de Cadastro - Final</label>
                <input
                  type="date"
                  name
                  id
                  class="form-control"
                  v-model="filters.whereBetween.created_at[1]"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">
              <i class="fa fa-close"></i> Fechar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="getThemeCategories"
              data-dismiss="modal"
            >
              <i class="fa fa-check"></i> Aplicar Filtros
            </button>
          </div>
        </div>
      </div>
    </div>


    <detail-modal
      @deleteEvents="deleteEvents"
      :enableDelete="enableDelete"
      :selectedEvent="selectedEvent"
      :selectedEvents="selectedEvents"
      :themes="themes"
    ></detail-modal>

    <event-config-modal
    :newEvent="newEvent"
    >  
    </event-config-modal>

  </div>
</template>

<script>
import { FullCalendar } from "vue-full-calendar";
import DetailModal from "./DetailModal";
import EventConfigModal from "./EventConfigModal.vue";

import Vue from "vue";
import App from "../../App";
import { store } from "../../main.js";

export default {
  data: function () {
    return {
      newEvent: '',
      themesSearchBar: "",
      filters: {
        paginated: false,
        special: "",
        theme_category_id: "",
        orderByDesc: "updated_at",
        whereBetween: {
          created_at: ["", ""],
        },
      },
      enableDelete: true,
      themeCategories: [],
      themes: [],
      filter_selected: {
        theme_category_id: "",
      },
      loadTheme: false,
      events: [],
      special: false,
      config: {
        locale: "pt-BR",
        timezone: "UTC",
        defaultView: "month",
        header: {
          left: "title",
          center: "",
          right: "today prev,next",
        },
        buttonText: {
          today: "Hoje",
        },
        displayEventTime: false,
        eventDrop: function (event, delta, revertFunc) {
          let url = store.getters.api;
          url = url + "events/" + event.id;

          axios.defaults.headers.common["authorization"] =
            "Bearer " + localStorage.getItem("token");

          axios
            .put(url, {
              dds_date: event.start.format("YYYY-MM-DD") + " 00:00:00",
            })
            .catch((e) => console.log(e));
        },
        editable: true,
        droppable: true,
      },
      selected: {},
      selectedEvents: [
        {
          team: {
            name: "",
          },
          shift: {
            name: "",
          },
          theme: {
            title: "",
          },
        },
      ],
      selectedEvent: {},
    };
  },
  methods: {
    timeNow() {
      let date = new Date();
      return date.getTime();
    },
    filter: function () {
      this.getThemes();
      $("#modal-filter").modal("hide");
    },
    deleteEvents() {
      this.getEvents();
    },
    eventClick: function (event, jsEvent, view) {
      const self = this;
      const api = self.$store.getters.api + "events?paginated=false";

      self.$http
        .get(api, {
          params: {
            dds_date: event.dds_date,
            with: [
              "theme",
              "team",
              "teams_shifts",
              "teams_shifts.team",
              "teams_shifts.shift",
              "status",
            ],
          },
        })
        .then((response) => {
          self.selectedEvents = response.data.data;

          self.selectedEvents.forEach(event => {
                event.editing = false;
                console.log('wtf')
                event.newTheme = event.theme;
                event.newTime = new Date(event.dds_date).toLocaleTimeString();
          });

          self.selectedEvent = event;
        })
        .then(() => {
          $("#detailModal").modal("show");
        });
    },
    getThemeCategories() {
      const self = this;
      const api =
        self.$store.state.api +
        "theme-categories?paginated=false&orderByAsc=description";

      self.$http
        .get(api)
        .then((response) => {
          self.themeCategories = response.data.data;
          self.getThemes();
        })
        .then(() => {
          if (self.id) {
            self.getModel();
          }
        })
        .catch((error) => {
          self.$error("Ocorreu um erro ao buscar as informações");
        });
    },
    initdrag() {
      const self = this;
      $("#external-events div.external-event").each(function () {
        $(this).draggable({
          zIndex: 90000,
          revert: true, // will cause the event to go back to its
          revertDuration: 0, //  original position after the drag
          revert: "invalid",
          cursor: "move",
          helper: "clone",
          appendTo: "body",
          containment: "window",
          scroll: true,
        });
      });
    },
    getThemes() {
      const self = this;

      self.loadTheme = false;
      // if (self.filter_selected.theme_category_id) {
      const api = self.$store.state.api + "themes" + self.prepareThemeUrl();

      self.$http
        .get(api)
        .then((response) => {
          self.themes = response.data.data;
          self.loadTheme = true;
        })
        .then(() => {
          self.initdrag();
        })
        .catch((error) => {
          self.$error("Ocorreu um erro ao buscar as informações");
        });
      // } else {
      //   self.themes = [];
      //   self.loadTheme = true;
      // // }
    },

    getEventsByFilter() {
      function getCalendarEvents(filter) {
        var events = new Array();
        if (filter == null) {
          events = calendar.fullCalendar("getThemeCategories");
        } else {
          events = getEventsByFilter(filter);
        }
        return events;
      }
    },
    getEvents() {
      const self = this;
      const api = self.$store.state.api + "events/plan";

      self.$http
        .get(api, {
          params: {
            paginated: false,
          },
        })
        .then((response) => {
          self.events = response.data;
        })
        .catch((error) => {
          self.$error("Ocorreu um erro ao buscar as informações");
        });
    },
    generate: function () {
      const self = this;
      const api = self.$store.state.api + "events/plan/generate";

      self.$http
        .post(api)
        .then((response) => {
          self.$message(null, "Programação gerada com sucesso", "success");
          self.getEvents();
        })
        .catch((error) => {
          self.$error("Não foi possível gerar a programação");
        });
    },
    eventReceive(event) {
      this.newEvent = event;
      $("#EventConfigModal").modal("show");
    },
    saveEvent(theme_id, date_event, status, event_time, team) {
      const self = this;
      const api = self.$store.state.api + "events";
      let event = {
        dds_date: date_event + ' ' + event_time,
        status_id: status,
        theme_id: theme_id,
        type: 1,
        team_id: team.id,
      }
      self.$http
        .post(api, event)
        .then((response) => {
          self.generate();
        })
        .catch(() => {
          self.$error("Ocorreu um erro ao salvar o tema!");
        });

      //self.updateEventsTheme(date_event, theme_id);
    },
    updateEventsTheme: function (dds_date, theme_id) {
      const self = this;
      const api =
        self.$store.state.api + "events/" + dds_date + "/update-theme";

      self.$http
        .put(api, {
          theme_id: theme_id,
        })
        .then((response) => {
          self.getEvents();
          self.$message(
            null,
            "O tema dos eventos foi atualizado com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$error("Não foi possível atualizar o tema");
        });
    },
    prepareThemeUrl: function () {
      let filters = "?with[]=theme_category&";
      this.filters.special = this.special ? 1 : 0;
      this.filters.theme_category_id = this.filter_selected.theme_category_id;
      $.each(this.filters, function (key, value) {
        if (key == "theme_category_id" && value == "") {
          return;
        }
        if (typeof value === "object") {
          $.each(value, function (key2, value2) {
            if (value2[0] && value2[1]) {
              filters += key + "[" + key2 + "][]=" + value2[0] + "&";
              filters += key + "[" + key2 + "][]=" + value2[1];
            }
          });
        } else {
          filters += key + "=" + value + "&";
        }
      });
      return filters;
    },
  },
  updated() {
    const self = this;
    self.initdrag();
  },
  watch: {
    themesCategoriseFiltered: function () {
      // const self = this
      // setTimeout( function() {
      //   self.initdrag()
      // },1000)
    },
  },
  computed: {
    themesFiltered: function () {
      return this.themes.filter((x) => {
        return x.title
          .toLowerCase()
          .includes(this.themesSearchBar.toLowerCase());
      });
    },
    themesCategoriseFiltered: function () {
      let themesCategoriseFiltered = [];
      for (let i = 0; i < this.themeCategorised.length; i++) {
        let themesArray = [];
        for (let j = 0; j < this.themeCategorised[i].items.length; j++) {
          if (
            this.themeCategorised[i].items[j].title
              .toLowerCase()
              .includes(this.themesSearchBar.toLowerCase())
          ) {
            themesArray.push(this.themeCategorised[i].items[j]);
          }
        }
        if (themesArray.length) {
          themesCategoriseFiltered.push({
            description: this.themeCategorised[i].description,
            items: themesArray,
          });
          console.log(themesCategoriseFiltered);
        }
      }
      return themesCategoriseFiltered;
    },
    themeCategorised: function () {
      let themeCategorised = [];
      this.themes.forEach((x) => {
        let position = null;
        for (let i = 0; i < themeCategorised.length; i++) {
          if (themeCategorised[i].description == x.theme_category.description) {
            position = i;
            break;
          }
        }

        if (position !== null) {
          themeCategorised[position].items.push(x);
        } else {
          let obj = {
            description: x.theme_category.description,
            items: [x],
          };
          themeCategorised.push(obj);
        }
      });
      return themeCategorised;
    },
  },
  components: {
    FullCalendar,
    DetailModal,
    EventConfigModal,
  },
  mounted() {
    this.getThemeCategories();
    this.getEvents();
  },
};
</script>

<style>
.ibox-tools a {
  cursor: pointer;
  margin-left: 5px;
  color: #676a6c;
}

.fc-event,
.fc-agenda .fc-event-time,
.fc-event a {
  padding: 4px 6px;
}

select.input-lg,
.input-group-lg > select.form-control,
.input-group-lg > select.input-group-addon,
.input-group-lg > .input-group-btn > select.btn {
  height: 44px;
  line-height: 44px;
}

.scrollBar {
  overflow-y: scroll;
  height: 200px;
  width: 100%;
  overflow-x: hidden;
}

.bg-orange {
  background-color: #f17436 !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Schedule/Index.vue